/* ==========================================================================
   LP Sampling 2026 — interações das landings de amostras.
   Carregado SOMENTE pelas sections lp-sampling-*. Só age em elementos com
   atributos data-lp-*; não toca em nada fora das landings.
   ========================================================================== */

(() => {
  if (window.__lpSampling) return; // a tag pode aparecer em várias sections
  window.__lpSampling = true;

  /* Configuração do resgate, renderizada pela section lp-sampling-config */
  function readConfig() {
    const el = document.getElementById('lp-sampling-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Insider: page_view com o nome da LP e ecom_add_to_cart no "Resgatar"
     (mesmo formato das LPs de oferta, lp-ofr.js, e do insider.js do oferta-v1).
     O ins.js carrega async: o page_view espera até ~10s por ele. */
  const insiderStamp = () => new Date().toISOString().replace(/\.\d{3}Z$/, 'Z');
  const insiderReady = () => window.Insider && typeof window.Insider.track === 'function';

  function insiderPageView(config) {
    // Uma vez por visita (o editor do tema chama init de novo a cada section)
    if (!config || !config.insiderPage || window.__lpSamplingInsiderView) return;
    window.__lpSamplingInsiderView = true;
    const send = () => {
      if (!insiderReady()) return false;
      const params = { src: 'web', url: window.location.href, page_name: config.insiderPage };
      window.Insider.track('events', [
        { event_name: 'page_view', timestamp: insiderStamp(), event_params: Object.assign({}, params, { custom: params }) },
      ]);
      return true;
    };
    if (send()) return;
    let tries = 0;
    const timer = setInterval(() => {
      if (send() || ++tries > 100) clearInterval(timer);
    }, 100);
  }

  // items: { id, name, price (R$) }; sem itens, o kit da página
  function insiderAddToCart(config, items) {
    try {
      if (!insiderReady() || !config.insiderPage) return;
      const list = items || [{ id: config.variantId, name: config.productTitle, price: config.insiderPrice }];
      window.Insider.track(
        'events',
        list.map((item) => ({
          event_name: 'ecom_add_to_cart',
          timestamp: insiderStamp(),
          event_params: {
            pid: String(item.id),
            c_product_name: item.name,
            p_price: item.price,
            c_event_source: config.insiderPage,
          },
        }))
      );
    } catch (e) {
      /* rastreio nunca impede o resgate */
    }
  }

  /* UTMs da visita no carrinho: o checkout da Shopify abre num link novo, sem as UTMs
     da LP, e elas não iam para o pedido. Gravadas como atributos do carrinho, aparecem
     no pedido em "Detalhes adicionais" (note_attributes), sem depender de cookie.
     Ficam na sessão para valer se o cliente sair e voltar à LP sem elas na URL. */
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const visitUtms = (() => {
    let utms = {};
    try {
      const params = new URLSearchParams(window.location.search);
      UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) utms[key] = value.slice(0, 255);
      });
      if (Object.keys(utms).length) sessionStorage.setItem('lp-sampling-utms', JSON.stringify(utms));
      else utms = JSON.parse(sessionStorage.getItem('lp-sampling-utms') || '{}') || {};
    } catch (e) {
      /* sem sessionStorage: só as da URL */
    }
    return utms;
  })();

  // Grava as 5 chaves sempre: vazio apaga a UTM de uma visita anterior que ficou no
  // carrinho. Nunca segura o resgate: desiste em 3s e o checkout segue.
  function saveUtms() {
    const attributes = {};
    UTM_KEYS.forEach((key) => (attributes[key] = visitUtms[key] || ''));
    const request = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    }).catch(() => {});
    return Promise.race([request, new Promise((resolve) => setTimeout(resolve, 3000))]);
  }

  // Mesmas UTMs nos links permanentes /cart/<variante>:1 (reserva sem JS do carrinho)
  function withUtms(url) {
    const pairs = UTM_KEYS.filter((key) => visitUtms[key]).map(
      (key) => `attributes[${key}]=${encodeURIComponent(visitUtms[key])}`
    );
    if (!pairs.length) return url;
    return url + (url.includes('?') ? '&' : '?') + pairs.join('&');
  }

  /* Botões "Resgatar": vão direto ao checkout com o kit de amostras
     (mesmo fluxo da section banner-sampling). Bloqueia se o cliente já
     resgatou (tag) ou se o kit esgotou. */
  function initCtas(scope, config) {
    scope.querySelectorAll('[data-lp-cta]').forEach((link) => {
      if (link.dataset.lpReady) return;
      link.dataset.lpReady = 'true';

      if (!config || !config.variantId) return;

      if (config.state !== 'available') {
        const label = config.state === 'claimed' ? config.labels.claimed : config.labels.soldOut;
        link.textContent = label;
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        link.classList.add('is-disabled');
        return;
      }

      link.href = withUtms(`/cart/${config.variantId}:1?checkout`);
      link.addEventListener('click', (event) => {
        // "Levar junto" marcado no hero: checkout com o kit da página + os kits marcados
        const addons = selectedAddons();
        if (addons.length) {
          event.preventDefault();
          if (link.dataset.lpBusy) return;
          link.dataset.lpBusy = 'true';
          link.setAttribute('aria-busy', 'true');
          checkoutWith(config, addons.map(addonItem), addonsDiscount());
          return;
        }
        // Com o modal de cross-sell na página, o Resgatar abre a oferta antes do checkout
        if (!link.dataset.lpBusy && openXsell(link)) {
          event.preventDefault();
          return;
        }
        if (checkoutKit(link, config)) event.preventDefault();
      });
    });
  }

  // Resgate só do kit da página. Devolve false quando quem navega é o próprio href.
  function checkoutKit(link, config) {
    if (window.mixpanel && typeof window.mixpanel.track === 'function') {
      window.mixpanel.track('Added to Cart', { name: config.productTitle });
    }
    if (!link.dataset.lpBusy) insiderAddToCart(config);

    // Mesmo fluxo do "go checkout" do Fastshop (handleMountAndGoCheckout):
    // limpa o carrinho, adiciona o kit e segue para /checkout.
    // Sem global.js, o href /cart/<variante>:1?checkout continua valendo.
    if (typeof window.addSelectedVariantToCart !== 'function') return false;
    if (link.dataset.lpBusy) return true;
    link.dataset.lpBusy = 'true';
    link.setAttribute('aria-busy', 'true');
    saveUtms()
      .then(() => window.addSelectedVariantToCart(config.variantId, 1, true))
      .catch(() => {
        delete link.dataset.lpBusy;
        link.removeAttribute('aria-busy');
        window.location.href = link.href;
      });
    return true;
  }

  /* Modal de cross-sell (section lp-sampling-crosssell): segundo kit antes do checkout.
     "Quero o combo" leva os dois kits (com o cupom do combo); "Seguir só com…",
     o X, o Esc ou tocar fora fazem o resgate de sempre, só com o kit da página. */
  const reais = (cents) => `R$${(cents / 100).toFixed(2).replace('.', ',')}`;
  let xsellLink = null;

  function openXsell(link) {
    const dialog = document.querySelector('[data-lp-xsell]');
    if (!dialog || typeof dialog.showModal !== 'function' || !dialog.querySelector('[data-lp-xsell-option]')) return false;
    if (!dialog.open) {
      xsellLink = link;
      dialog.showModal();
      dialog.scrollTop = 0;
      document.documentElement.classList.add('lp-xsell-open');
    }
    return true;
  }

  function initXsell(dialog, config) {
    if (dialog.dataset.lpReady) return;
    dialog.dataset.lpReady = 'true';

    const options = [...dialog.querySelectorAll('[data-lp-xsell-option]')];
    const radios = options.map((option) => option.querySelector('input[type="radio"]'));
    const base = Number(dialog.dataset.basePrice) || 0;
    const line = dialog.querySelector('[data-lp-xsell-line]');
    const lineLabel = dialog.querySelector('[data-lp-xsell-line-label]');
    const linePrice = dialog.querySelector('[data-lp-xsell-line-price]');
    const total = dialog.querySelector('[data-lp-xsell-total]');
    const combo = dialog.querySelector('[data-lp-xsell-combo]');
    const solo = dialog.querySelector('[data-lp-xsell-solo]');
    const selected = () => radios.find((radio) => radio.checked);

    const update = () => {
      const radio = selected();
      const extra = radio ? Number(radio.dataset.price) || 0 : 0;
      options.forEach((option, i) => option.classList.toggle('is-selected', radios[i] === radio));
      line.hidden = !radio;
      lineLabel.textContent = radio ? radio.dataset.summary : '';
      linePrice.textContent = reais(extra);
      total.textContent = reais(base + extra);
      combo.textContent = (dialog.dataset.comboLabel || '').replace('[total]', reais(base + extra)).trim();
      combo.disabled = !radio;
    };

    // A primeira marca vem marcada (como no Figma)
    if (radios.length && !selected()) radios[0].checked = true;
    radios.forEach((radio) => radio.addEventListener('change', update));
    update();

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('lp-xsell-open');
      // Devolve o foco ao botão que abriu (o Safari não foca links no clique)
      if (xsellLink && document.contains(xsellLink)) xsellLink.focus({ preventScroll: true });
    });
    // Recusar a oferta (X, tocar fora, Esc ou "Seguir só com…") segue para o checkout
    // só com o kit da página, sem o kit marcado no modal
    const checkoutSolo = () => {
      const link = xsellLink;
      if (dialog.open) dialog.close();
      if (!config || !link) return;
      if (!checkoutKit(link, config)) window.location.href = link.href;
    };
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) checkoutSolo();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      checkoutSolo();
    });
    dialog.querySelectorAll('[data-lp-xsell-close]').forEach((button) => {
      button.addEventListener('click', checkoutSolo);
    });
    solo.addEventListener('click', checkoutSolo);

    combo.addEventListener('click', () => {
      const radio = selected();
      if (!config || !radio || combo.dataset.lpBusy) return;
      combo.dataset.lpBusy = 'true';
      combo.setAttribute('aria-busy', 'true');

      checkoutWith(config, [addonItem(radio)], dialog.dataset.discount);
    });
  }

  /* Checkout com o kit da página + kits extras (combo do modal ou "Levar junto" do
     hero): carrinho só com eles, UTMs da visita no carrinho e cupom opcional. Se a
     API do carrinho falhar, o link permanente /cart/<a>:1,<b>:1 faz o mesmo.
     extras: [{ id, name, price (R$) }] */
  function checkoutWith(config, extras, code) {
    if (window.mixpanel && typeof window.mixpanel.track === 'function') {
      window.mixpanel.track('Added to Cart', { name: config.productTitle });
      extras.forEach((extra) => window.mixpanel.track('Added to Cart', { name: extra.name }));
    }
    insiderAddToCart(config, [{ id: config.variantId, name: config.productTitle, price: config.insiderPrice }, ...extras]);

    const query = code ? `?discount=${encodeURIComponent(code)}` : '';
    const post = (url, body) =>
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      }).then((res) => {
        if (!res.ok) throw new Error(`Carrinho indisponível (${res.status})`);
        return res;
      });
    const items = [{ id: Number(config.variantId), quantity: 1 }, ...extras.map((extra) => ({ id: Number(extra.id), quantity: 1 }))];
    post('/cart/clear.js')
      .then(() => post('/cart/add.js', { items }))
      .then(saveUtms)
      .then(() => {
        window.location.href = `/checkout${query}`;
      })
      .catch(() => {
        window.location.href = withUtms(`/cart/${items.map((item) => `${item.id}:1`).join(',')}${query}`);
      });
  }

  // Kit extra a partir do input (rádio do modal ou checkbox do "Levar junto")
  function addonItem(input) {
    return { id: input.value, name: input.dataset.product, price: (Number(input.dataset.price) || 0) / 100 };
  }

  /* "Levar junto" (blocos addon do hero): outros kits somados ao Resgatar. Com
     "Só uma opção por pedido", marcar uma desmarca as outras. */
  function selectedAddons() {
    return [...document.querySelectorAll('[data-lp-addons] input[type="checkbox"]:checked')];
  }

  function addonsDiscount() {
    const group = document.querySelector('[data-lp-addons]');
    return group ? group.dataset.discount : '';
  }

  function initAddons(group) {
    if (group.dataset.lpReady) return;
    group.dataset.lpReady = 'true';
    const inputs = [...group.querySelectorAll('input[type="checkbox"]')];
    const sync = () => inputs.forEach((input) => input.closest('[data-lp-addon]').classList.toggle('is-checked', input.checked));
    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked && group.hasAttribute('data-exclusive')) {
          inputs.forEach((other) => {
            if (other !== input) other.checked = false;
          });
        }
        sync();
      });
    });
    sync();
  }

  /* Voltar do checkout (bfcache) não pode deixar o botão preso no spinner */
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-lp-busy]').forEach((link) => {
      delete link.dataset.lpBusy;
      link.removeAttribute('aria-busy');
    });
  });

  /* Abas: [data-lp-tab] atualiza imagem/texto da própria section */
  function initTabs(group) {
    if (group.dataset.lpReady) return;
    group.dataset.lpReady = 'true';

    const tabs = group.querySelectorAll('[data-lp-tab]');
    const root = group.closest('[data-lp-section]') || document;
    const images = root.querySelectorAll('[data-lp-tabs-image]');
    const quote = root.querySelector('[data-lp-tabs-quote]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });

        if (tab.dataset.image) {
          images.forEach((img) => {
            img.src = tab.dataset.image;
            img.alt = tab.dataset.alt || '';
          });
        }

        if (quote && tab.dataset.quote) {
          quote.textContent = tab.dataset.quote;
        }
      });
    });
  }

  /* Indicador de rolagem do carrossel (mobile) */
  function initScrollbar(bar) {
    if (bar.dataset.lpReady) return;
    bar.dataset.lpReady = 'true';

    const scroller = document.getElementById(bar.dataset.lpScrollbar);
    const thumb = bar.querySelector('span');
    if (!scroller || !thumb) return;

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const progress = max > 0 ? scroller.scrollLeft / max : 0;
      thumb.style.setProperty('--lp-scroll', `${progress * (bar.clientWidth - thumb.offsetWidth)}px`);
    };

    scroller.addEventListener('scroll', update, { passive: true });
    // ResizeObserver no próprio elemento: sem listener global que sobra no editor de temas
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(scroller);
    else window.addEventListener('resize', update);
    update();
  }

  /* Barra fixa: aparece quando o primeiro CTA do hero sai da tela por cima */
  function initBar(bar) {
    if (bar.dataset.lpReady) return;
    bar.dataset.lpReady = 'true';

    const trigger = document.querySelector('[data-lp-bar-trigger]');
    if (!trigger || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(trigger);

    // Reserva, dentro do rodapé (mesma cor), a altura da barra para ela não
    // cobrir o fim da página — ver .footer-wrapper::after no lp-sampling.css
    const reserve = () => {
      document.body.style.setProperty('--lp-bar-space', `${bar.offsetHeight}px`);
    };
    reserve();
    if ('ResizeObserver' in window) new ResizeObserver(reserve).observe(bar);
    else window.addEventListener('resize', reserve);
  }

  /* Hero: animação Lottie do kit. A imagem estática (já no HTML) é só a reserva —
     o script inline da section mostra a imagem se a animação não ficar pronta em 4s;
     aqui a animação assume quando fica pronta, e a reserva volta se algo falhar. */
  let lottieLib = null;

  // Roda depois do evento load (na hora, se a página já carregou — ex.: editor do tema)
  function afterLoad(fn) {
    if (document.readyState === 'complete') setTimeout(fn, 0);
    else window.addEventListener('load', () => setTimeout(fn, 0), { once: true });
  }

  function loadLottieLib(src) {
    if (window.lottie && typeof window.lottie.loadAnimation === 'function') return Promise.resolve(window.lottie);
    if (!lottieLib) {
      lottieLib = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => (window.lottie ? resolve(window.lottie) : reject(new Error('Lottie indisponível')));
        script.onerror = () => reject(new Error('Falha ao carregar o player Lottie'));
        document.head.appendChild(script);
      });
    }
    return lottieLib;
  }

  // Alinha a animação como a imagem de reserva (object-fit/object-position do recorte atual)
  function lottieAspect(img) {
    if (!img) return 'xMidYMid meet';
    const style = getComputedStyle(img);
    const [x = '50%', y = '50%'] = style.objectPosition.split(' ');
    const axis = (value, min, mid, max) => {
      const n = parseFloat(value);
      if (n <= 0) return min;
      return n >= 100 ? max : mid;
    };
    return `${axis(x, 'xMin', 'xMid', 'xMax')}${axis(y, 'YMin', 'YMid', 'YMax')} ${style.objectFit === 'cover' ? 'slice' : 'meet'}`;
  }

  function initLottie(media) {
    if (media.dataset.lpReady) return;
    media.dataset.lpReady = 'true';

    // Carregamento leve no celular (hero "Celular: carregamento leve"): fica a imagem
    if (media.hasAttribute('data-lp-lottie-desktop-only') && window.matchMedia('(max-width: 1199px)').matches) {
      media.classList.remove('is-lottie-pending');
      media.classList.add('is-lottie-fallback');
      return;
    }

    const player = media.querySelector('[data-lp-lottie-player]');
    const fallback = media.querySelector(':scope > img, :scope > picture > img');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let anim = null;

    const fail = () => {
      media.classList.remove('is-lottie-pending', 'is-lottie-ready');
      media.classList.add('is-lottie-failed');
      if (anim) anim.destroy();
      anim = null;
    };

    if (!player) {
      fail();
      return;
    }

    // Só baixa e monta a animação depois que a página terminou de carregar: no iPhone,
    // disputar memória com o carregamento inicial derrubava a aba. Até lá vale a mesma
    // regra de sempre (reserva escondida e, passados 4s, a imagem estática).
    afterLoad(() => {
      Promise.all([
        loadLottieLib(media.dataset.lpLottieLib),
        fetch(media.dataset.lpLottie).then((res) => {
          if (!res.ok) throw new Error(`Animação indisponível (${res.status})`);
          return res.json();
        }),
      ])
        .then(([lottie, data]) => {
          anim = lottie.loadAnimation({
            container: player,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            animationData: data,
            rendererSettings: {
              preserveAspectRatio: lottieAspect(fallback),
              ...(media.dataset.lpLottieViewbox && { viewBoxSize: media.dataset.lpLottieViewbox }),
            },
          });
          anim.addEventListener('data_failed', fail);
          anim.addEventListener('error', fail);
          anim.addEventListener('DOMLoaded', () => {
            if (!anim) return;
            const svg = player.querySelector('svg');
            if (svg) {
              svg.setAttribute('aria-hidden', 'true');
              // Com a área ampliada, tira o recorte da composição para mostrar o que passa da borda
              if (media.dataset.lpLottieViewbox) {
                svg.querySelectorAll(':scope > g[clip-path]').forEach((g) => g.removeAttribute('clip-path'));
              }
            }
            media.classList.remove('is-lottie-pending', 'is-lottie-fallback');
            media.classList.add('is-lottie-ready');

            // Recorte do mobile pode alinhar diferente (ex.: kit apoiado embaixo)
            window.matchMedia('(max-width: 1199px)').addEventListener('change', () => {
              if (svg) svg.setAttribute('preserveAspectRatio', lottieAspect(fallback));
            });

            // Movimento reduzido: mostra a composição completa, parada
            if (reduceMotion) {
              anim.goToAndStop(Math.round(anim.totalFrames / 2), true);
              return;
            }
            // Só anima enquanto o hero está na tela
            if (!('IntersectionObserver' in window)) {
              anim.play();
              return;
            }
            new IntersectionObserver(([entry]) => {
              if (!anim) return;
              if (entry.isIntersecting) anim.play();
              else anim.pause();
            }).observe(media);
          });
        })
        .catch(fail);
    });
  }

  /* Tabela nutricional: [data-lp-nutri-open] abre o <dialog data-lp-nutri>
     (modal no desktop, gaveta no mobile). Fecha no X, no Esc ou tocando fora. */
  function initNutrition(scope) {
    const findDialog = () => document.querySelector('[data-lp-nutri]');

    scope.querySelectorAll('[data-lp-nutri-open]').forEach((button) => {
      if (button.dataset.lpReady) return;
      button.dataset.lpReady = 'true';

      // Sem a section da tabela na página, o link não leva a lugar nenhum
      if (!findDialog() && !(window.Shopify && window.Shopify.designMode)) {
        button.hidden = true;
        return;
      }

      button.addEventListener('click', () => {
        const dialog = findDialog();
        if (!dialog || typeof dialog.showModal !== 'function') return;
        dialog.lpOpener = button;
        dialog.showModal();
        dialog.scrollTop = 0;
        document.documentElement.classList.add('lp-nutri-open');
      });
    });

    const dialog = scope.matches && scope.matches('[data-lp-nutri]') ? scope : scope.querySelector('[data-lp-nutri]');
    if (!dialog || dialog.dataset.lpReady) return;
    dialog.dataset.lpReady = 'true';

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('lp-nutri-open');
      // Devolve o foco ao link (o Safari não foca botões no clique)
      if (dialog.lpOpener) dialog.lpOpener.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.querySelectorAll('[data-lp-nutri-close]').forEach((close) => {
      close.addEventListener('click', () => dialog.close());
    });
  }

  function trackView(config) {
    if (!config || window.__lpSamplingViewed) return;
    if (window.mixpanel && typeof window.mixpanel.track === 'function') {
      window.__lpSamplingViewed = true;
      window.mixpanel.track('Product Viewed', {
        name: config.productTitle,
        price: config.productPrice,
        brand: config.productVendor,
        variant: config.variantSku,
      });
    }
  }

  /* Título do hero em no máximo 2 linhas: o script logo abaixo do título (section
     lp-sampling-hero) já ajusta a fonte antes da página aparecer; aqui ele é refeito
     quando as fontes carregam e quando a largura da tela muda. */
  function fitHeroTitle(title) {
    if (title.dataset.lpFit) return;
    title.dataset.lpFit = 'true';
    const fit = () => {
      if (typeof window.lpFitHeroTitle === 'function') window.lpFitHeroTitle(title);
    };
    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(fit);
    };
    // As fontes do Typekit podem chegar depois do fonts.ready: refaz a cada fonte
    // carregada e no fim do carregamento da página
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(schedule);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', schedule);
    }
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
    // No iPhone o resize dispara a cada vez que a barra de endereço some/volta na
    // rolagem; só a largura muda a quebra de linha
    let width = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth === width) return;
      width = window.innerWidth;
      schedule();
    });
  }

  /* Carrossel da oferta (section lp-sampling-offer, mesmo do advertorial): rolagem
     com snap, setas, miniaturas e teclado */
  function initGallery(root) {
    if (root.dataset.lpReady) return;
    root.dataset.lpReady = 'true';
    const slides = root.querySelector('[data-lp-gallery-slides]');
    if (!slides) return;
    const thumbs = [...root.querySelectorAll('[data-lp-gallery-thumb]')];
    const thumbCol = root.querySelector('[data-lp-gallery-thumbs]');
    const prev = root.querySelector('[data-lp-gallery-go="-1"]');
    const next = root.querySelector('[data-lp-gallery-go="1"]');
    const count = slides.children.length;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let ticking = false;

    function sync(i) {
      index = i;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= count - 1;
      thumbs.forEach((thumb, j) => {
        if (j === i) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      // Mantém a miniatura ativa visível na coluna rolável
      const active = thumbs[i];
      if (thumbCol && active && thumbCol.scrollHeight > thumbCol.clientHeight) {
        const c = thumbCol.getBoundingClientRect();
        const r = active.getBoundingClientRect();
        if (r.top < c.top || r.bottom > c.bottom) thumbCol.scrollTop += r.top - c.top - (c.height - r.height) / 2;
      }
    }

    function goTo(i) {
      const target = Math.max(0, Math.min(count - 1, i));
      slides.scrollTo({ left: target * slides.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      sync(target);
    }

    slides.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
          if (i !== index) sync(i);
        });
      },
      { passive: true }
    );
    slides.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
      }
    });
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));
    sync(0);
  }

  function init(scope = document) {
    const config = readConfig();
    scope.querySelectorAll('.lp-hero__title').forEach(fitHeroTitle);
    initCtas(scope, config);
    scope.querySelectorAll('[data-lp-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-lp-scrollbar]').forEach(initScrollbar);
    scope.querySelectorAll('[data-lp-bar]').forEach(initBar);
    scope.querySelectorAll('[data-lp-lottie]').forEach(initLottie);
    initNutrition(scope);
    scope.querySelectorAll('[data-lp-addons]').forEach(initAddons);
    scope.querySelectorAll('[data-lp-gallery]').forEach(initGallery);
    const xsell = scope.matches && scope.matches('[data-lp-xsell]') ? [scope] : scope.querySelectorAll('[data-lp-xsell]');
    xsell.forEach((dialog) => initXsell(dialog, config));
    trackView(config);
    insiderPageView(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  /* Editor de temas: sections recarregadas individualmente */
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
